const compare = require('./compare')
const gt = (a, b, loose) => compare(a, b, loose) > 0
module.exports = gt



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/gt.js
// module id = 256
// module chunks = 0